/**
 * @file paddle Live Hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import { useEffect, useState } from 'react';
import moment from 'moment';

import { fetchGetLiveData } from '../../api/pages/liveApi';

import { IBanner } from './components/banner/types';
import { ILiveCard } from './components/live-card/types';
import { ILiveCalendar } from './components/live-calendar/types';

// 预请求
let preRequest: any = {
    fetchGetLiveData: fetchGetLiveData()
};

const useLiveHooks = () => {
    const [banner, setBanner] = useState<IBanner>();
    const [liveCard, setLiveCard] = useState<ILiveCard>();
    const [liveCalendar, setLiveCalendar] = useState<ILiveCalendar>();

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetLiveData || fetchGetLiveData();
            delete preRequest.fetchGetLiveData;

            let res;

            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const pageData = res.body.result?.pageData || {};

                const ba = pageData.banner || {};
                const baBtns: any[] = Array.isArray(ba.btns) ? ba.btns : [];
                setBanner({
                    title: ba.title,
                    subtitle: ba.subtitle,
                    btns: baBtns.map((btn) => ({
                        label: btn.label,
                        href: btn.href
                    }))
                });


                const lc = pageData.liveCard || {};
                const lcList: any[] = Array.isArray(lc.list) ? lc.list : [];
                const lca = pageData.liveCalendar || {};
                const lcaLiveTypes: any[] = Array.isArray(lca.liveTypes) ? lca.liveTypes : [];
                const lcaLiveList: any[] = Array.isArray(lca.liveList) ? lca.liveList : [];
                setLiveCard({
                    title: lc.title,
                    subtitle: lc.subtitle,
                    topList: lcList.map((t) => ({
                        key: ''
                            + t.title
                            + t.avatar
                            + t.author
                            + t.authorTitle
                            + t.beforeBtnText
                            + t.beforeLink
                            + t.btnText
                            + t.link
                            + t.afterBtnText
                            + t.afterLink
                            + t.liveTypesKey
                            + t.startTime
                            + t.endTime,
                        title: t.title,
                        author: t.author,
                        authorTitle: t.authorTitle,
                        content: t.content,
                        beforeBtnText: t.beforeBtnText,
                        beforeLink: t.beforeLink,
                        btnText: t.btnText,
                        link: t.link,
                        afterLink: t.afterLink,
                        afterBtnText: t.afterBtnText,
                        liveTypesKey: t.liveTypesKey,
                        startTime: t.startTime && moment(t.startTime).isValid() ? moment(t.startTime) : undefined,
                        endTime: t.endTime && moment(t.endTime).isValid() ? moment(t.endTime) : undefined,
                        offlineAddress: t.offlineAddress
                    })),
                    list: lcaLiveList.map((t) => ({
                        key: ''
                            + t.title
                            + t.avatar
                            + t.author
                            + t.authorTitle
                            + t.beforeBtnText
                            + t.beforeLink
                            + t.btnText
                            + t.link
                            + t.afterBtnText
                            + t.afterLink
                            + t.liveTypesKey
                            + t.startTime
                            + t.endTime,
                        title: t.title,
                        avatar: t.avatar,
                        author: t.author,
                        authorTitle: t.authorTitle,
                        content: t.content,
                        beforeBtnText: t.beforeBtnText,
                        beforeLink: t.beforeLink,
                        btnText: t.btnText,
                        link: t.link,
                        afterBtnText: t.afterBtnText,
                        afterLink: t.afterLink,
                        liveTypesKey: t.liveTypesKey,
                        startTime: t.startTime && moment(t.startTime).isValid() ? moment(t.startTime) : undefined,
                        endTime: t.endTime && moment(t.endTime).isValid() ? moment(t.endTime) : undefined,
                        offlineAddress: t.offlineAddress
                    }))
                });
                setLiveCalendar({
                    title: lca.title,
                    liveTypes: lcaLiveTypes.map(t => ({
                        title: t.title,
                        color: t.color,
                        liveTypesKey: t.liveTypesKey
                    })),
                    liveList: lcaLiveList.map(t => ({
                        key: ''
                            + t.title
                            + t.avatar
                            + t.author
                            + t.authorTitle
                            + t.beforeBtnText
                            + t.beforeLink
                            + t.btnText
                            + t.link
                            + t.afterBtnText
                            + t.afterLink
                            + t.liveTypesKey
                            + t.startTime
                            + t.endTime,
                        title: t.title,
                        avatar: t.avatar,
                        author: t.author,
                        authorTitle: t.authorTitle,
                        content: t.content,
                        beforeBtnText: t.beforeBtnText,
                        beforeLink: t.beforeLink,
                        btnText: t.btnText,
                        link: t.link,
                        afterBtnText: t.afterBtnText,
                        afterLink: t.afterLink,
                        liveTypesKey: t.liveTypesKey,
                        startTime: t.startTime && moment(t.startTime).isValid() ? moment(t.startTime) : undefined,
                        endTime: t.endTime && moment(t.endTime).isValid() ? moment(t.endTime) : undefined,
                        offlineAddress: t.offlineAddress
                    }))
                });
            }
        })();
    }, []);

    return {
        banner,
        liveCard,
        liveCalendar
    };
};

export default useLiveHooks;
